import React from "react";
import { Dropdown } from "react-bootstrap";
import {
  FaEllipsisV,
  FaStar,
  FaTrash,
  FaRegEye,
  FaRegEdit,
  FaRegStar
} from "react-icons/fa";
import { CiCalendarDate } from "react-icons/ci";
const NotesCard = ({ note, onDelete, onView,onEdit }) => {
  return (
    <div className="note-card">
      
      {/* HEADER */}
      <div className="card-header-custom">
        <span className={`badge-custom ${note.priority.toLowerCase()}`}>
          ● {note.priority}
        </span>

        <Dropdown align="end">
          <Dropdown.Toggle className="menu-toggle">
            <FaEllipsisV />
          </Dropdown.Toggle>

          <Dropdown.Menu className="menu-dropdown">
            <Dropdown.Item onClick={onEdit}> 
              <FaRegEdit  className="me-2" /> Edit
            </Dropdown.Item>

            <Dropdown.Item onClick={onDelete}>
              <FaTrash className="me-2 text-danger" /> Delete
            </Dropdown.Item>

            <Dropdown.Item>
              <FaRegStar className="me-2" /> Not Important
            </Dropdown.Item>

            <Dropdown.Item onClick={onView}>
              <FaRegEye className="me-2" /> View
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* BODY */}
      <div className="card-body-custom">
        <h6 className="title">{note.title}</h6>
<div  style={{ display: "flex", alignItems: "center" }} className=" date g-2">
          <CiCalendarDate className="mb-3"/>
        <p >{note.date}</p>
</div>
        <div className="parent" >
          <p className="desc">{note.desc}</p>
        </div>
      </div>

      {/* FOOTER */}
      <div className="card-footer-custom">
   <div className="user">
  <img src="https://i.pravatar.cc/40" alt="user" />
  <span className="tag personal bg-none">
    <i className="diamond"></i>
    Personal
  </span>
</div>
        <div className="actions">
          <FaStar className="star" />
          <FaTrash className="delete" onClick={onDelete} />
        </div>
      </div>
      <style>
          {
               `
               /* GRID SCROLL */
.notes-scroll {
  max-height: 75vh;
  overflow-y: auto;
  padding-right: 5px;
}

/* CARD */
.note-card {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  border: 2px solid #eee;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 270px;
  width:"80px";
}

/* HEADER */
.card-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* BADGE */
.badge-custom {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 6px;
}

.badge-custom.low {
  border: 1px solid #dc3545;
  color: #dc3545;
}

.badge-custom.medium {
  border: 1px solid #ffc107;
  color: #ffc107;
}

.badge-custom.high {
  border: 1px solid #198754;
  color: #198754;
}

/* MENU */
.menu-toggle {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.menu-dropdown {
  border-radius: 8px;
  padding: 5px 0;
  min-width: 180px;
}

.menu-dropdown .dropdown-item {
  padding: 8px 12px;
  font-size: 14px;
}

/* BODY */
.card-body-custom {
  flex: 1;
}

.title {
  font-weight: 700;
  font-size: 19px;
  margin-top: 10px;
  color: #000000;

}

.date {
  font-size: 16px;
  color: #0c0c0c;
}

.desc {
  font-size: 17px;
  color: #53575b;
  margin-top: 6px;
  font-weight: 400;
  line-height: 1.6;

  border-bottom: 1px solid #eee;
  padding-bottom: 10px;

  white-space: normal;      /* 🔥 IMPORTANT */
  word-break: break-word;
}

/* FOOTER */
.card-footer-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.parent {
  display: flex;
  flex-direction: column;  
   display: -webkit-box;
  -webkit-line-clamp: 3;      /* show only 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden; /* 🔥 REQUIRED */
}
.user {
  display: flex;
  align-items: center;
}

.user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 6px;
}

/* ACTIONS */
.actions {
  display: flex;
  gap: 10px;
}

.star {
  color: #ffc107;
  cursor: pointer;
}

.delete {
  color: #dc3545;
  cursor: pointer;
}


.user {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Avatar */
.user img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

/* Tag text */
.tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
}

/* Diamond shape */
.diamond {
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  display: inline-block;
}

/* Colors */
.tag.personal {
  color: #0d6efd;   /* blue */
}

.tag.personal .diamond {
  background: #0d6efd;
}

.tag.work {
  color: #00b894;   /* green */
}

.tag.work .diamond {
  background: #00b894;
}


// colors
.tag.personal {
  color: #0d6efd !important;
}

.tag.work {
  color: #00b894 !important;
}

.tag.personal .diamond {
  background: #0d6efd !important;
}

.tag.work .diamond {
  background: #00b894 !important;
}
/* RESPONSIVE */
@media (max-width: 768px) {
  .note-card {
    min-height: auto;
  }
}`
          }
      </style>
    </div>
  );
};

export default NotesCard;